declare global {
  interface Window {
    __MEDIA_DEBUG__?: Array<{ time: number; msg: string }>;
  }
}

// const MEDIA_DEBUG_HOST = 'web217.ssg18app.com';
const MEDIA_DEBUG_HOST = 'web.ssg01.com';
const MAX_LOG = 50;

export function isMediaDebugEnabled() {
  if (typeof window === 'undefined') return false;

  const { hostname } = window.location;

  return hostname === 'localhost'
    || hostname === '127.0.0.1'
    || hostname === MEDIA_DEBUG_HOST;
}

export function mediaDebugLog(...args: any[]) {
  if (typeof window === 'undefined' || !isMediaDebugEnabled()) return;

  const msg = args.map((arg) => {
    try {
      return typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
    } catch {
      return String(arg);
    }
  }).join(' ');

  // eslint-disable-next-line no-console
  console.log('[media]', msg);

  if (!window.__MEDIA_DEBUG__) {
    window.__MEDIA_DEBUG__ = [];
  }

  window.__MEDIA_DEBUG__.push({
    time: Date.now(),
    msg,
  });

  if (window.__MEDIA_DEBUG__.length > MAX_LOG) {
    window.__MEDIA_DEBUG__.shift();
  }
}
